import {observer} from 'mobx-react-lite'
import React from 'react'
import {Hub} from 'yougile-model'
import {ProjectCard} from '@components/common/base/project-card'
import {crmStore} from '@components/crm/crm-store'
import {canInvite, isProjectMine} from '@components/dashboard/dashboard-utils'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {useCompanyProjectsStore} from '../company-projects-store'
import {useProjectItemMenu} from './use-project-item-menu'

export interface ProjectListItemProps {
  project: Hub
  users: UserProxy[]
}

export const ProjectListItem = observer(
  ({project, users}: ProjectListItemProps) => {
    const [state, store] = useCompanyProjectsStore()
    const menuItems = useProjectItemMenu(project, store)
    const onAddUser = canInvite(project)
      ? store.projectParticipantsOpen
      : undefined

    return (
      <ProjectCard
        id={project.id}
        title={project.title}
        users={users}
        menuItems={menuItems}
        alien={!isProjectMine(project)}
        onClick={store.goToProject}
        onAddUserClick={onAddUser}
        draggable={!state.projectsEditedProjectId}
        dragged={state.projectsDraggedProjectId === project.id}
        onDragStart={store.projectsDragStart}
        onDragEnd={store.projectsDragEnd}
        onDragEnter={store.projectsDragEnter}
        hoverable={!state.projectsDraggedProjectId}
        titleEditing={state.projectsEditedProjectId === project.id}
        onTitleSubmit={store.submitProjectTitle}
        isCrmProject={crmStore.isCrmProject(project)}
      />
    )
  }
)
